export default {
  updateValue(type, id, key, value, name) {
    const payload = { type, id, value, name, key };
    console.log("valueChange", payload);
    this.$store.commit("testDetail/setActionUpdate", payload);
    this.$event.$emit("update:action", payload);
  },
  saveAction(actionId) {
    console.log("saveAction", actionId);
    Object.entries(this.$store.state.testDetail.actionUpdate[actionId]).map(([key, value]) => {
      console.log(key, value.value);
    });
  },
  resetValue(id) {
    this.$store.commit("testDetail/setActionUpdate", { id });
  },
  getNewTag(action_id) {
    let newaddedaction = false;
    let testJobId =
      this.$store.state.testDetail?.tabsData.tabs.find(
        (tab) => tab.resource_id == this.$store.state.testDetail?.tabsData?.defaultTab
      )?.executed_job_id ?? "";
    let globalNewTagData = JSON.parse(
      JSON.stringify(this.$store.state.testDetail.globalNewTagData)
    );

    if (
      globalNewTagData &&
      globalNewTagData[testJobId] &&
      globalNewTagData[testJobId].includes(action_id)
    ) {
      newaddedaction = true;
    }
    /*
    const currbrowser = this.$route.params.browserId;
    const sideMenuTempArr = this.$store.state.sideMenuTempArr;
    if (
      (this.$store.state.liveDebugJobIds[currbrowser] ||
        this.$store.state.liveExecutionJobIds[currbrowser]) &&
      typeof sideMenuTempArr[currbrowser] != "undefined" &&
      typeof sideMenuTempArr[currbrowser][action_id] != "undefined" &&
      sideMenuTempArr[currbrowser][action_id] == 1
    ) {
      newaddedaction = false;
    }
    */
    console.trace("getNewTag", newaddedaction, action_id, testJobId, globalNewTagData);
    return newaddedaction;
  },
};
